import React, { FC } from "react";
import { useParams } from "react-router-dom";
import Box from "../Box";
import DashboardHeader from "../DashboardHeader";
import AppointmentTableContainer from "../../Appointment/AppointmentTableContainer";
import AppointmentOfferingTableContainer from "../../AppointmentOffering/AppointmentOfferingTableContainer";
import AppointmentAIReportsTableContainer from "../../AppointmentAIReport/AppointmentAIReportsTableContainer";
import useDate from "./useDate";

const DashboardScreen: FC = () => {
  const { role } = useParams();

  const { startDate, endDate, zonedDate } = useDate();

  switch (role) {
    case "technologist":
      return (
        <>
          <Box pb={2.5}>
            <DashboardHeader
              type="studiesToRead"
              date={startDate}
              role={role}
            />
          </Box>
          <AppointmentOfferingTableContainer
            startDate={startDate}
            endDate={endDate}
            role={role}
          />
        </>
      );
    case "receptionist":
      return (
        <>
          <Box pb={2.5}>
            <DashboardHeader date={startDate} role={role} />
          </Box>
          <AppointmentOfferingTableContainer
            startDate={startDate}
            endDate={endDate}
            role={role}
          />
        </>
      );
    case "radiologist": {
      return (
        <>
          <Box pb={2.5}>
            <DashboardHeader type="aiReports" date={startDate} role={role} />
          </Box>
          <Box pb={6}>
            <AppointmentAIReportsTableContainer role={role} />
          </Box>
          <Box pb={2.5}>
            <DashboardHeader
              type="studiesToRead"
              date={startDate}
              role={role}
            />
          </Box>
          <AppointmentOfferingTableContainer
            startDate={startDate}
            endDate={endDate}
            role={role}
          />
        </>
      );
    }
    default: {
      return (
        <>
          <Box pb={2.5}>
            <DashboardHeader date={zonedDate} role={role} />
          </Box>
          <AppointmentTableContainer date={startDate} role={role} />
        </>
      );
    }
  }
};

export default DashboardScreen;
